import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { formatThousands } from "../../../_helpers/numberFormatter";
import { actionScripts } from "../../../_helpers/actionScripts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse } from "reactstrap";
import ProjectStatusBubble from "../../_common/ProjectStatusBubble";
import { docPermConstants } from "../../../_constants/permissionConstants";

class AdminProjectsDetails extends Component {
  state = {
    showProjDetails: true,
  };

  componentDidMount() {
    // Override state with props
    const { collapseDetails } = this.props;
    if (collapseDetails) this.setState({ showProjDetails: false });
  }

  handleClick_toggleProjDetails = (e) => {
    e.preventDefault();
    this.setState({ showProjDetails: !this.state.showProjDetails });
  };

  handleClick_openProjDash = (e) => {
    const { project } = this.props;
    e.preventDefault();
    actionScripts.OPEN_PROJ_DASH.run(project.projectId);
  };

  handleClick_openProjAssignment = (e) => {
    const { project } = this.props;
    e.preventDefault();
    actionScripts.OPEN_PROJ_ASSIGNMENT.run(project.projectId);
  };

  handleClick_registerInProDMS = (e) => {
    e.preventDefault();
    this.props.toggleAlert_registerProjectInProDMS();
  };

  handleClick_deactivateProject = (e) => {
    e.preventDefault();
    this.props.toggleAlert_deactivateProject();
  };

  handleClick_deleteProject = (e) => {
    e.preventDefault();
    this.props.toggleAlert_deleteProject();
  };

  renderDate = (date) => (date ? moment(date).format("MM/DD/YYYY") : "(N/A)");

  renderProjectUnitRow = (pu, rowIndex) => (
    <li key={`puRowKey_${rowIndex}`} className="list-group-item py-1 pl-1">
      <div className="row">
        <div className="col-3 pr-1">
          <span>{pu.distUnit}</span>
        </div>
        <div className="col-5 px-1">
          <span>{pu.description}</span>
        </div>
        <div className="col-4 px-1">
          <span>{pu.unitManagerFullName}</span>
        </div>
      </div>
    </li>
  );

  renderProjectStaffRow = (ps, rowIndex) => (
    <li key={`psRowKey_${rowIndex}`} className="list-group-item py-1 pl-1">
      <div className="row">
        <div className="col-6 pr-1">
          <span>{ps.staffFullName}</span>
        </div>
        <div className="col-6 px-1">
          <span>{ps.projectRoleDescription}</span>
        </div>
      </div>
    </li>
  );

  render() {
    const { showProjDetails } = this.state;
    const {
      fetching,
      project,
      showButtons,
      showUnitsAndStaff,
      handleClick_editProjectInfo,
      permissions,
    } = this.props;
    return (
      <>
        {project ? (
          <React.Fragment>
            <h3 className="card-title mb-1">{project.fullEA}</h3>
            <h5 className="text-muted">{project.distCoRtePm}</h5>
          </React.Fragment>
        ) : fetching ? (
          <h5 className="text-muted">Loading...</h5>
        ) : (
          <h5 className="text-muted">No Project Selected</h5>
        )}
        {project && (
          <React.Fragment>
            <div className="form-row mb-3 ml-1">
              <button
                type="button"
                name="showProjDetails"
                id="showProjDetails"
                className="btn btn-sm btn-outline-secondary"
                onClick={this.handleClick_toggleProjDetails}
              >
                <FontAwesomeIcon
                  className="fa-fw text-muted"
                  icon={showProjDetails ? "caret-up" : "caret-right"}
                />
                {showProjDetails ? "Hide Details" : "Show Details"}
              </button>
            </div>
            <Collapse isOpen={showProjDetails}>
              <div className="row">
                <div className="col pr-1">
                  <ul className="list-group-flush pl-0 border-bottom border-top mb-2">
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>EFIS:</b>
                        </div>
                        <div className="col pl-1">{project.efis || "(N/A)"}</div>
                      </div>
                    </li>
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Status</b>
                        </div>
                        <div className="col pl-1">
                          <ProjectStatusBubble status={project.projectStatus} />
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col">
                          <b>Work Description:</b>
                          <br />
                          {project.workDescription}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Engr. Est:</b>
                        </div>
                        <div className="col pl-1">
                          {"$" + formatThousands(project.engineersEstimate)}
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="col pl-1">
                  <ul className="list-group-flush pl-0 border-bottom border-top mb-2">
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Bid Opening:</b>
                        </div>
                        <div className="col pl-1">
                          {this.renderDate(project.bidOpeningDate)}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Award:</b>
                        </div>
                        <div className="col pl-1">
                          {this.renderDate(project.contractAwardDate)}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Approval:</b>
                        </div>
                        <div className="col pl-1">
                          {this.renderDate(project.contractApprovalDate)}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>1st WD:</b>
                        </div>
                        <div className="col pl-1">
                          {this.renderDate(project.firstWorkingDay)}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Working Days:</b>
                        </div>
                        <div className="col pl-1">{project.workingDays}</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </Collapse>
            {showButtons && (
              <React.Fragment>
                <div className="d-flex flex-row flex-wrap align-items-start">
                  {project.isProDMSProject ? (
                    <React.Fragment>
                      <button
                        type="button"
                        className="btn btn-sm btn-secondary mr-2"
                        name="editProjInfo"
                        id="editProjInfo"
                        onClick={handleClick_editProjectInfo}
                        disabled={!project.isProDMSProject}
                      >
                        Edit/View Project Info...
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        name="openProjDash"
                        id="openProjDash"
                        onClick={this.handleClick_openProjDash}
                        disabled={!project.isProDMSProject}
                      >
                        Open Project Dashboard
                      </button>
                    </React.Fragment>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-sm btn-info"
                      name="registerInProDMS"
                      id="registerInProDMS"
                      onClick={this.handleClick_registerInProDMS}
                    >
                      Register Project in ProDMS
                    </button>
                  )}
                </div>
                {permissions.includes(docPermConstants.DELETE) &&
                  (project.isProDMSProject || !project.isPRSMListed) && (
                    <div className="d-flex flex-row flex-wrap align-items-start mt-3 pt-2 border-top">
                      {project.isProDMSProject && (
                        <button
                          type="button"
                          className="btn btn-sm btn-danger mr-2"
                          name="deactivateProject"
                          id="deactivateProject"
                          onClick={this.handleClick_deactivateProject}
                        >
                          Deactivate Project
                        </button>
                      )}
                      {!project.isPRSMListed && (
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          name="deleteProject"
                          id="deleteProject"
                          onClick={this.handleClick_deleteProject}
                        >
                          Delete Project...
                        </button>
                      )}
                    </div>
                  )}
              </React.Fragment>
            )}
            {project.isProDMSProject && showUnitsAndStaff && (
              <>
                <hr />
                <h5>Project Units</h5>
                <ul className="list-group-flush pl-0 border-bottom mb-2">
                  <li
                    key={`puHeaderKey`}
                    className="list-group-item py-1 pl-1 bg-lightgray"
                  >
                    <div className="row">
                      <div className="col-3 pr-1">
                        <b>Dist-Unit</b>
                      </div>
                      <div className="col-5 px-1">
                        <b>Description</b>
                      </div>
                      <div className="col-4 px-1">
                        <b>Unit Mgr.</b>
                      </div>
                    </div>
                  </li>
                  {project &&
                    (project.projectUnits.length > 0 ? (
                      project.projectUnits.map((pu, index) =>
                        this.renderProjectUnitRow(pu, index)
                      )
                    ) : (
                      <li className="list-group-item py-1 pl-1">No data</li>
                    ))}
                </ul>
                <h5>Project Staff</h5>
                <ul className="list-group-flush pl-0 border-bottom mb-2">
                  <li
                    key={`psHeaderKey`}
                    className="list-group-item py-1 pl-1 bg-lightgray"
                  >
                    <div className="row">
                      <div className="col-6 pr-1">
                        <b>Name</b>
                      </div>
                      <div className="col-6 px-1">
                        <b>Project Role</b>
                      </div>
                    </div>
                  </li>
                  {project.projectStaff &&
                    (project.projectStaff.length > 0 ? (
                      project.projectStaff.map((ps, index) =>
                        this.renderProjectStaffRow(ps, index)
                      )
                    ) : (
                      <li className="list-group-item py-1 pl-1">No data</li>
                    ))}
                </ul>
                <small>Edit project staff assignments using Mini-WEAT.</small>
                <br />
                {showButtons && (
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    name="openProjDash"
                    id="openProjDash"
                    onClick={this.handleClick_openProjAssignment}
                    disabled={!project.isProDMSProject}
                  >
                    Open Project Assignments (Mini-WEAT)
                  </button>
                )}
              </>
            )}
          </React.Fragment>
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  appSettings: state.appSettings,
  fetching: state.projects.fetching,
  project: state.projects.openProjectDetails[ownProps.projectId] || null,
});

export default connect(mapStateToProps)(AdminProjectsDetails);
